import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonProps } from '@node-space/storybook-components/dist/Button'
import Icon from '@node-space/storybook-components/dist/Icon'
import { Description } from 'components/Text'
import { FinpromResultModal } from 'pages/Finprom/components/FinpromResultModal'
import { useRetakeSelfCategorisation } from 'pages/Finprom/hooks/useRetakeSelfCategorisation'
import { TextAlignType } from 'types/text'

export const PassedModal = () => {
  const { t } = useTranslation()
  const { quizCategoryLabel, onRetakeQuiz } = useRetakeSelfCategorisation() || {}

  const onContinue = () => {
    // TODO: handle submit to appropriateness request - ONB-1507
  }

  const retakeQuizAction: ButtonProps = {
    children: t('finprom.selfCategorisation.noRetakeQuiz'),
    secondary: true,
    onClick: onRetakeQuiz,
  }

  const continueAction: ButtonProps = {
    children: t('yes'),
    onClick: onContinue,
  }

  return (
    <FinpromResultModal
      title={`${t('result')}: ${quizCategoryLabel}`}
      icon={<Icon name={'CheckBadgeIcon'} />}
      actions={[retakeQuizAction, continueAction]}
    >
      <Description align={TextAlignType.CENTER}>
        {`${t('finprom.selfCategorisation.thankYouForCompleting')} ${t(
          'finprom.selfCategorisation.resultUnsuccessful',
          { category: quizCategoryLabel?.toLocaleLowerCase() }
        )}`}
      </Description>
      <Description align={TextAlignType.CENTER}>
        {t('finprom.selfCategorisation.correctCategory')}
      </Description>
    </FinpromResultModal>
  )
}
